import { createSlice } from '@reduxjs/toolkit';

import MenuInfo from 'data/menu';

const initialState = {
    monitoring: null
};


const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        changeActiveMenu(state, action) {
            let root = MenuInfo.ROOT;
            root.active({id: action.payload});
        }
    }
});

export let { changeActiveMenu } = menu.actions;

export default menu.reducer;